import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { LANGUAGES, findLanguage } from "../../i18n/languages";
import { FLAG_BY_CODE } from "./FlagIcons";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const current = findLanguage(i18n.language);
  const CurrentFlag = FLAG_BY_CODE[current.code] || FLAG_BY_CODE.en;

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        onClick={(e) => setAnchorEl(e.currentTarget)}
        endIcon={<KeyboardArrowDownRoundedIcon />}
        sx={{
          color: "text.primary",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
          px: 1.25,
          py: 0.75,
          minWidth: 0,
          gap: 0.75,
          "&:hover": { borderColor: "primary.main", bgcolor: "action.hover" },
        }}
      >
        <CurrentFlag />
        <Box component="span" sx={{ fontWeight: 700, display: { xs: "none", sm: "inline" } }}>
          {current.short}
        </Box>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              minWidth: 240,
              maxHeight: 360,
              borderRadius: 2.5,
              border: "1px solid",
              borderColor: "divider",
              backgroundImage: "none",
            },
          },
          list: {
            sx: { py: 0.5 },
          },
        }}
      >
        {LANGUAGES.map(({ code, label }) => {
          const selected = current.code === code;
          const Flag = FLAG_BY_CODE[code] || FLAG_BY_CODE.en;
          return (
            <MenuItem
              key={code}
              selected={selected}
              onClick={() => handleSelect(code)}
              sx={{ borderRadius: 1.5, mx: 0.5, my: 0.25 }}
            >
              <ListItemIcon sx={{ minWidth: 34 }}>
                <Flag />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ fontWeight: selected ? 700 : 500, fontSize: 14 }}>
                {label}
              </ListItemText>
              {selected && <CheckRoundedIcon fontSize="small" color="primary" />}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
